import { Box, Typography } from '@mui/material';

const formatHex = (value: string): string => {
  const trimmed = value.trim().toUpperCase();
  return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
};

export type ColorSwatchProps = {
  color: string;
  size?: number;
};

export const ColorSwatch = ({ color, size = 24 }: ColorSwatchProps) => {
  const isInvalid = !/^#?[0-9A-Fa-f]{3,8}$/.test(color);
  const value = isInvalid ? color : formatHex(color);

  return (
    <Box display='flex' alignItems='center' gap={1}>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: 1.5,
          backgroundColor: isInvalid ? 'white' : value,
          border: (theme) =>
            `1px solid ${isInvalid ? theme.palette.error.main : theme.palette.divider}`,
          flexShrink: 0,
        }}
      />
      <Typography variant='body2' color='text.primary' component='span'>
        {value}
      </Typography>
    </Box>
  );
};
